/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ detail: NonNullable<unknown> }} Cc_Embed_Error_UnsupportedInputs */



/**
* | output |
* | --- |
* | "This file uses something local processing doesn't support yet: {detail}" |
*
* @param {Cc_Embed_Error_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cc_embed_error_unsupported = /** @type {((inputs: Cc_Embed_Error_UnsupportedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_Embed_Error_UnsupportedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ce fichier utilise une fonctionnalité que le traitement local ne prend pas encore en charge : ${i?.detail}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Diese Datei verwendet etwas, das die lokale Verarbeitung noch nicht unterstützt: ${i?.detail}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Questo file utilizza qualcosa che l'elaborazione locale non supporta ancora: ${i?.detail}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`В этом файле используется то, что пока не поддерживается локальной обработкой: ${i?.detail}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Este archivo utiliza algo que el procesamiento local aún no admite: ${i?.detail}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`此文件使用了本地处理尚不支持的功能：${i?.detail}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`このファイルは、ローカル処理がまだサポートしていないものを使用しています: ${i?.detail}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`यह फ़ाइल एक ऐसी चीज़ का उपयोग करती है जिसे स्थानीय प्रोसेसिंग अभी तक सपोर्ट नहीं करती है: ${i?.detail}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Este arquivo usa algo que o processamento local ainda não suporta: ${i?.detail}`)
	return /** @type {LocalizedString} */ (`This file uses something local processing doesn't support yet: ${i?.detail}`)
});